import { ApolloError } from "@apollo/client";
import { GetProjectFileQueryVariables, useGetProjectFileLazyQuery } from "generated/graphql";
import { useCallback, useMemo } from "react";

const isMissingProjectFileError = (error: ApolloError | undefined) => {
  if (!error) {
    return false;
  }

  return error.graphQLErrors.some((graphQLError) =>
    /No query results for model \[App\\Models\\ProjectFile\]/i.test(graphQLError.message || "")
  );
};

export const useGetProjectFileLazy = () => {
  const [query, { loading, error, data }] = useGetProjectFileLazyQuery({
    fetchPolicy: "cache-first",
    errorPolicy: "all",
  });

  const missing = useMemo(() => isMissingProjectFileError(error), [error]);

  const graphqlData = useMemo(() => {
    if (missing) {
      return null;
    }

    return data?.getProjectFile || null;
  }, [data, missing]);

  const safeError = useMemo(() => {
    return missing ? undefined : error;
  }, [error, missing]);

  const getProjectFile = useCallback(
    ({ id }: GetProjectFileQueryVariables) => {
      query({ variables: { id } });
    },
    [query]
  );

  return [getProjectFile, { loading, error: safeError, graphqlData, missing }] as const;
};
